import { ReactNode } from 'react';
import { FieldSchema } from '../../hooks/useSchema';
import { fieldLabel, OnFieldChange } from './Common';
import { ValidationErrors } from './useValidationErrors';

export interface FormControlBaseProps {
    row: any;
    field: string;
    schema: FieldSchema;
}

interface KnownExtraProps {
    labelIdPrefix: string;
    showValues: boolean;
    visibleIf: (x:any) => boolean;
    disabled: boolean;
    readOnly: boolean;
    utcToLocal: boolean;
    withArea: boolean;
    autoRows: boolean;
    hint: ReactNode;
    emptyLabel?: string;
    wrapperStyle?: React.CSSProperties;
    editable: boolean;
    controlProps?: any;
    cellStyle?: React.CSSProperties;
}

export type ExtraProps = Partial<KnownExtraProps> & Record<any, any>;

export interface DisplayProps extends FormControlBaseProps {
    config?: ExtraProps;
}

export interface FormControlProps extends FormControlBaseProps {
    extraProps?: ExtraProps;
    onChange: OnFieldChange;
    errors?: ValidationErrors;
    error?: boolean;
}

interface ExpandedProps extends FormControlProps {
    label: string;
    value: any;
    controlProps?: any;
    isVisible: boolean;
}

export const expandProps = (props: FormControlProps): ExpandedProps => {
    const { row, field, schema, extraProps, error, errors } = props;

    const extraControlProps = {
        ...(extraProps?.disabled ? { disabled: true } : {}),
        ...(extraProps?.readOnly ? { readOnly: true } : {}),
    };
    const inputProps = { maxLength: (schema || {})["max-length"], minLength: (schema || {})["min-length"], ...(extraProps?.controlProps || {}) };
    const controlProps = { margin: "dense", ...extraProps?.controlProps, view: {...extraProps || {}}, ...extraControlProps, inputProps: inputProps };
    const hasError = error || (errors && errors?.fieldHasErrors(field)) || undefined;

    return {
        ...props,
        error: hasError,
        value: row[field],
        label: extraProps?.label || fieldLabel(schema, field),
        controlProps: controlProps,
        isVisible: extraProps?.visibleIf ? extraProps.visibleIf(row) as boolean : true,
    }
}
